module.exports = __webpack_public_path__ + "static/media/upload-image.4fc0f452.svg";